<script>
export default {
  props: {
    searchFields: Array,
    showBton:{
      default:true
    },
    downLoadBton:{
      default:false
    }
  },
  data() {
    return {
      searchParams: {},
      changeWith:120
    }
  },
  watch: {
    searchFields: {
      deep: true,
      immediate: true,
      handler() {
        // const tempArr = this.searchFields?.filter(item => item.selectKey)
        // if (tempArr?.length) {
        //   tempArr.forEach(item => {
        //     this.$set(this.searchParams, [item.selectKey], item.options[0]?.value || '')
        //   })
        // }
        this.searchFields.forEach(item => {
          if (item.selectKey) {
            this.$set(this.searchParams, [item.selectKey], item.selectValue || item.options[0]?.value || '')
          }
          if (Object.prototype.hasOwnProperty.call(item, 'defaultValue')) {
            this.$set(this.searchParams, item.prop, item.defaultValue)
          }
          if (Object.prototype.hasOwnProperty.call(item, 'inputValue') && item.type === 'selectInput') {
            this.$set(this.searchParams, item.prop, item.inputValue || '')
          }
        })
        this.$nextTick(() => {
          this.calcPaddingLeft()
        })
      }
    }
  },
  beforeMount() {
    this.searchFields?.forEach(field => {
      this.$set(this.searchParams, field.prop, field.defaultValue || '')
    })
  },
  mounted() {
    this.calcPaddingLeft()
  },
  methods: {
    changeWidthHandle(options,arr) {
      let maxWidth = ''
      arr.forEach(item => {
        if (item.value == options) {
           maxWidth = item.label.length;
        }
      })
      this.changeWith = maxWidth* 5  + 88;
    },
    autoSearchHandler(){
      this.$emit('autoSearch', this.searchParams)
    },
    searchHandler() {
      this.$emit('search', this.searchParams)
    },
    downLoadHandle(){
      this.$emit('downLoadHandle', this.searchParams)
    },
    clearParams() {
      this.searchParams = {}
      const item = this.searchFields.find(item => item.type === 'selectInput')
      if (item) {
        this.$set(this.searchParams, item.selectKey, item.options[0]?.value || '')
      }
      this.$emit('clear', this.searchParams)
    },
    calcPaddingLeft() {
      // 适用于 input, select的label长度计算，设置 input框的padding-left
      this.$nextTick(() => {
        const id = this.$attrs.id
        const eles = document.querySelectorAll(id ? '#' + id + ' .needStyle' : '.needStyle')
        eles.forEach(ele => {
          const eleInput = ele.querySelector('.el-input__inner')
          const elePrefix = ele.querySelector('.el-input__prefix')
          eleInput.style.paddingLeft = elePrefix.getBoundingClientRect().width + 30 + 'px'
        })
        // 适用于日期类型的padding-left计算
        const dateEles = document.querySelectorAll('.needStyleDate')
        dateEles.forEach(ele => {
          const eleInput = ele.querySelector('.el-input__inner')
          const slot = ele.querySelector('.slot')
          eleInput.style.paddingLeft = slot.getBoundingClientRect().width + 8 + 'px'
        })
      })
    },
    getOptionLabel(item, option) {
      return option[item.option_label] || option.label || ''; // 如果 option_label 不存在，则尝试返回默认的 'label' 或空字符串
    },
    getOptionValue(item, option){
      return option[item.option_value] || option.value || ''; // 如果 option_label 不存在，则尝试返回默认的 'label' 或空字符串
    }
  }
}
</script>

<template>
  <div class="search-container">
    <div class="search-box">
      <!-- 直接移除v-if="$slots.input || $slots.select"，因为我们不再直接依赖于插槽存在与否 -->
      <div :class="[
              ['input', 'select', 'selectInput'].includes(item.type) ? 'input-container' : '',
              ['date'].includes(item.type) ? 'search-date' : '',
            ]"
           v-for="(item, key) in searchFields"
           :key="key"
      >
        <el-input
            class="needStyle"
            @keyup.enter.native="searchHandler"
            v-if="item.type === 'input'" :placeholder="item.placeholder" v-model.trim="searchParams[item.prop]">
          <div slot="prefix">
            {{ item.label }}:
          </div>
        </el-input>
        <el-input
            v-if="item.type === 'selectInput'"
            :placeholder="item.placeholder" v-model.trim="searchParams[item.prop]">
          <el-select
            v-model="searchParams[item.selectKey]" slot="prepend" :style="{ width:changeWith + 'px' }"
            @change="(value) => changeWidthHandle(value, item.options)">
            <el-option
                v-for="(sitem, index) in item.options"
                :key="index"
                :label="sitem.label"
                :value="sitem.value"></el-option>
          </el-select>
        </el-input>
        <el-select
          @change="autoSearchHandler"
            class="needStyle"
            v-if="item.type === 'select'" v-model="searchParams[item.prop]" :placeholder="item.placeholder">
          <el-option
              v-for="option in item.options"
              :key="option.value"
              :value="getOptionValue(item,option)"
              :label="getOptionLabel(item,option)"
          ></el-option>
          <div slot="prefix">
            {{ item.label }}:
          </div>
          <div style="clear: both">
          </div>
        </el-select>
        <div class="needStyleDate" v-if="item.type === 'date'">
          <el-date-picker
            clear-icon
              v-model="searchParams[item.prop]"
              type="date"
              :placeholder="item.placeholder"
              @change="autoSearchHandler"
              value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          <div class="slot">{{ item.label }}:</div>
        </div>
      </div>
      <div class="search-buttons">
        <el-button @click="searchHandler"  v-show="showBton" type="success" round style="width: 80px;padding: 0">Search</el-button>
        <el-button @click="clearParams"  v-show="showBton" plain style="width: 80px" class="changeFocus">Clear</el-button>
        <div class="inner_yellow_bton">
          <el-button @click="downLoadHandle"  v-show="downLoadBton"  class="yellowBton">Download</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
.yellowBton{
  background: #FFC215;
  border-radius: 16px;
  border: 1px solid #FFC215;
  color: #fff;
}
.inner_yellow_bton{
  display: inline-block;
  /deep/.el-button:focus, .el-button:hover, .el-button:active{
    background: #f9c017 !important;
    border-radius: 16px !important;
    border: 1px solid #f9c017 !important;
    color: #fff;
  }
}

.search-container {
  padding: 16px;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;

  /deep/ .changeFocus:focus {
    border: 1px solid #dcdfe6;
    color: #606266;
  }

  .search-box {
    font-family: SFPro, SFPro;
    font-weight: bold;
    font-size: 14px;
    color: #1F2D42;
    line-height: 20px;
    text-align: left;

    display: flex;
    flex-wrap: wrap;
    align-content: center;
    justify-content: space-between;
    gap: 16px;
    width: 100%;

    .search-buttons {
      margin-left: auto; /* 这会使得.search-buttons元素尽可能地靠右对齐 */
    }

    .input-container {
      width: calc(25% - 12px);

      /deep/ .el-input--prefix .el-input__inner {
        //padding-left: 112px;
      }

      /deep/ .el-input__prefix {
        color: #1f2d42;
      }
      /deep/ .el-input-group{
        .el-input--suffix {
          .el-input__inner {
            border-color: transparent !important;
          }
        }
      }

      &.long_search /deep/ .el-input__inner {
        padding-left: 115px !important;
      }

      &.long_searchs /deep/ .el-input__inner {
        padding-left: 133px !important;
      }
    }

    .select-container {
      margin: 8px;

      /deep/ .el-cascader {
        line-height: 0;
      }


    }

    .search-date {
      width: calc(25% - 12px);

      position: relative;

      /deep/ .el-input__inner {
        padding-left: 80px;
      }

      .slot {
        position: absolute;
        padding-left: 24px;
        font-size: 14px;
        top: 50%;
        transform: translateY(-50%);
      }

      /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 100% !important;
      }

      /deep/ .el-input__prefix {
        position: absolute;
        top: 0;
        right: 12px !important;
        left: auto;
      }

      /deep/ .el-input--prefix .el-input__inner {
        padding-left: 12px;
      }

      /deep/ .el-input__icon {
        color: #000000;
      }
    }


    .ex {
      width: 300px;

      /deep/ .el-input--prefix .el-input__inner {
        padding-left: 110px;
      }
    }
  }

  .button-container {
    display: flex;
    align-items: center;

    .el-button {
      margin-left: 8px;
    }
  }
}
</style>
